document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-swh-collection-search]').forEach(function (toolbar) {
    var input = toolbar.querySelector('[data-swh-search-input]');
    if (!input) return;

    var section = toolbar.closest('.swh-collection');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-swh-search-card]'));
    var count = toolbar.querySelector('[data-swh-visible-count]');
    var empty = section.querySelector('[data-swh-no-results]');

    input.addEventListener('input', function () {
      var query = input.value.trim().toLocaleLowerCase('nl-NL');
      var visible = 0;

      cards.forEach(function (card) {
        var title = (card.getAttribute('data-product-search') || '').toLocaleLowerCase('nl-NL');
        var match = !query || title.indexOf(query) !== -1;
        card.hidden = !match;
        if (match) visible += 1;
      });

      if (count) count.textContent = visible;
      if (empty) empty.hidden = visible !== 0;
    });
  });
});
